<template>
  <v-row>
    <v-col md="2">
      <v-text-field
        v-model="part.name"
        :label="$t(partTranslationKey + '.name')"
        outlined
        dense
        @change="validationModel.name.$touch()"
        :error-messages="errorMessages('name')"
      />
    </v-col>
    <v-col md="2">
      <v-text-field
        v-model="part.purchaseOrder"
        :label="$t('part.orderNumber')"
        dense
        outlined
        counter="64"
        @change="validationModel.purchaseOrder.$touch()"
        :error-messages="errorMessages('purchaseOrder')"
      />
    </v-col>
    <template v-if="!form.isMultiCurrency">
      <v-col md="2">
        <v-text-field
          v-model="ratio"
          :label="$t('part.ratio')"
          outlined
          dense
          type="number"
          append-icon="mdi-percent-outline"
          @change="validationModel.ratio.$touch()"
          :error-messages="errorMessages('ratio')"
          :disabled="form.isMultiCurrency || !!part.currentPriceCent"
        />
      </v-col>
      <v-col v-if="!form.isMultiCurrency">
        {{ part.signedPriceCents | formatCurrency(mainCurrency) }}
      </v-col>
    </template>
    <template v-else>
      <v-col>
        <v-text-field
          v-model="ratio"
          :label="$t('part.ratio')"
          outlined
          dense
          type="number"
          append-icon="mdi-percent-outline"
          disabled
        />
      </v-col>
      <v-col cols="2">
        <vf-currency-input
          v-model="part.signedPriceCents"
          :currency="{ key: part.currency, value: 1 }"
          :label="$t(partTranslationKey + '.price')"
          outlined
          dense
          @change="validationModel.signedPriceCents.$touch()"
          :error-messages="errorMessages('signedPriceCents')"
          :disabled="!!part.currentPriceCents"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="part.currency"
          :items="currencies"
          :label="$t('part.currency')"
          outlined
          dense
          item-value="code"
          item-text="code"
          :disabled="!!part.currentPriceCents"
        />
      </v-col>
      <v-col cols="2">
        <AddressList
          :label="$tc('part.contractor', 1)"
          v-model="part.contractor"
          :items="contractors"
          dense
          @addNew="handleAddContractor"
        />
      </v-col>
    </template>
    <v-col cols="1">
      <v-btn
        v-if="index"
        rounded
        dense
        color="error"
        fab
        x-small
        :disabled="!!part.currentPriceCents"
        @click="$emit('remove', index)"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { getLocalizationContext } from '@/helpers/translations'

export default {
  name: 'PartsForm',
  props: {
    index: {
      type: Number,
      default: 0
    },
    part: {
      type: Object,
      default: () => ({})
    },
    validationModel: {
      type: Object,
      default: () => ({})
    },
    errorMessages: {
      type: Function,
      default: () => {}
    },
    form: {
      type: Object
    },
    mainCurrency: Object
  },
  data () {
    return { }
  },
  watch: {
    'part.currency' (v) {
      this.$emit('calculate-rations')
    },
    'part.signedPriceCents' (v) {
      this.$emit('calculate-rations')
    }
  },
  computed: {
    ...mapState({
      currencies: (state) => state.currencies,
      contractors: (state) => state.contractors
    }),
    ratio: {
      get () {
        return this.part.ratio
      },
      set (value) {
        this.part.ratio = value
        if (!this.form.isMultiCurrency) {
          this.part.signedPriceCents = (value / 100) * this.form.signedPriceCents
        }
      }
    },
    partTranslationKey () {
      return getLocalizationContext(this.form.isMultiCurrency)
    }
  },
  methods: {
    handleAddContractor () {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'ContractorForm',
        options: { maxWidth: 650 },
        handlers: {
          setnewcontractor: (item) => {
            this.part.contractor = item
          }
        }
      })
    }
  }
}
</script>
